import { Component, Input, OnInit, signal, ViewChild } from '@angular/core';
import { HomeService } from 'src/app/core/services/home.service';
import { Solution } from 'src/app/core/models/solutions-events';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'solutions',
  templateUrl: './solutions.component.html',
  styleUrls: ['./solutions.component.scss'],
  standalone: false,
})
export class SolutionsComponent implements OnInit {
  @ViewChild('owlCarousel') owlCarousel: any;

  @Input() solutions: Solution[];
  @Input() isFetching: boolean;

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    autoHeight: true,
    navText: ['', ''],
    margin: 16,
    responsive: {
      0: {
        items: 1,
      },
      750: {
        items: 2,
      },
      1150: {
        items: 3,
      },
    },
    nav: true,
  };

  constructor() {}

  ngOnInit(): void {}

  prevSlide() {
    this.owlCarousel.prev();
  }

  nextSlide() {
    this.owlCarousel.next();
  }

  disablePrevSlide() {
    return this.owlCarousel?.navData()?.prev.disabled;
  }

  disableNextSlide() {
    return this.owlCarousel?.navData()?.next.disabled;
  }
}
